import React from 'react';
import { WorkHistoryAndGapMenuProps } from './interface';
import { Button, Icon, Box, Text } from '@medely/ui-kit';
import { useNoOutlineWrapper } from '@mp/components/AssignmentFavoriteButton/useNoOutlineWrapper';
import { useMediaQuery } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Slide, { SlideProps } from '@mui/material/Slide';
import { lightTheme } from '@medely/web-components/themes';

const DialogTransition = (props: SlideProps) => (
  <Slide direction="up" {...props} timeout={{ enter: 300, exit: 200 }} />
);

export const WorkHistoryAndGapMenu = ({
  onWorkGapClick,
  onClinicalExperienceClick,
  onNonClinicalExperienceClick,
}: WorkHistoryAndGapMenuProps) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const isDesktop = useMediaQuery(lightTheme.breakpoints.up('sm'));
  const { wrapWithNoOutline } = useNoOutlineWrapper('experience-add-button', true);

  const toggleDialog = (open: boolean) => {
    setIsOpen(open);
  };

  const handleOption = (callback: () => void) => {
    callback();
    toggleDialog(false);
  };

  const trigger = (
    <Button
      variant="text"
      onClick={() => toggleDialog(true)}
      testId="experience-button"
      color="primary"
      startIcon={<Icon name="plus" variant="custom" color="state.teal.secondary" iconSize="16px" />}
    >
      Add
    </Button>
  );

  return (
    <Box>
      {wrapWithNoOutline(trigger)}
      <Dialog
        open={isOpen}
        onClose={() => toggleDialog(false)}
        fullScreen={!isDesktop}
        fullWidth={!isDesktop}
        maxWidth={false}
        TransitionComponent={isDesktop ? undefined : DialogTransition}
        BackdropProps={{ sx: !isDesktop ? { backgroundColor: 'rgba(0, 0, 0, 0.5)' } : {} }}
        PaperProps={{
          sx: isDesktop
            ? {
                borderRadius: '8px',
                maxHeight: '60vh',
                margin: '32px',
                width: '90vw',
                maxWidth: '400px',
              }
            : {
                borderRadius: '16px 16px 0 0',
                margin: 0,
                marginTop: 'auto',
                maxHeight: '20vh',
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                width: '100vw',
              },
        }}
      >
        <DialogContent
          sx={{
            padding: 0,
            maxHeight: isDesktop ? '40vh' : 'calc(50vh - 60px)',
            overflowY: 'auto',
          }}
        >
          <div
            onClick={() => handleOption(onClinicalExperienceClick)}
            data-testid="add-work-history-option"
            style={{
              cursor: 'pointer',
              padding: '16px',
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
              borderBottom: '1px solid #E0E0E0',
            }}
          >
            <Text size="l">Add clinical experience</Text>
          </div>
          <div
            onClick={() => handleOption(onNonClinicalExperienceClick)}
            data-testid="add-work-history-option"
            style={{
              cursor: 'pointer',
              padding: '16px',
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
              borderBottom: '1px solid #E0E0E0',
            }}
          >
            <Text size="l">Add non-clinical experience</Text>
          </div>
          <div
            onClick={() => handleOption(onWorkGapClick)}
            data-testid="add-work-gap-option"
            style={{
              cursor: 'pointer',
              padding: '16px',
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
            }}
          >
            <Text size="l">Add work gap</Text>
          </div>
        </DialogContent>
      </Dialog>
    </Box>
  );
};
